
<div class="signin-content">
  <mat-card class="img-login">
    <div class="logo">

      <img [src]="ymLogoPng" alt="EasyRin">

    </div>
    <!-- <div class="loader_snipper" *ngIf="isloading">
      <mat-spinner strokeWidth="5" [diameter]="50"></mat-spinner>
  </div> -->
  <div class="hero-copy">
    <p class="er-eyebrow">Retailer Portal</p>
    <h4 class="er-join">
      Money moves<br><span class="er-rin">on a yes</span>.</h4>
    <h5 class="er-hindi">
      हाँ के बाद ही पैसा आगे बढ़ता है।
    </h5>

    <ul class="er-features">
      <li>
        <span class="material-icons er-fico">account_balance</span>
        <div class="er-ftext">
          <b>AEPS banking</b>
          <small>Aadhaar-enabled cash services</small>
        </div>
      </li>
      <li>
        <span class="material-icons er-fico">send</span>
        <div class="er-ftext">
          <b>Money transfer</b>
          <small>Instant transfers to any bank</small>
        </div>
      </li>
      <li>
        <span class="material-icons er-fico">receipt_long</span>
        <div class="er-ftext">
          <b>Recharges &amp; bills</b>
          <small>Mobile, DTH and BBPS payments</small>
        </div>
      </li>
      <li>
        <span class="material-icons er-fico">badge</span>
        <div class="er-ftext">
          <b>PAN card services</b>
          <small>New PAN and corrections</small>
        </div>
      </li>
      <li>
        <span class="material-icons er-fico">point_of_sale</span>
        <div class="er-ftext">
          <b>Micro ATM</b>
          <small>Card withdrawals at your shop</small>
        </div>
      </li>
      <li>
        <span class="material-icons er-fico">account_balance_wallet</span>
        <div class="er-ftext">
          <b>Cash management</b>
          <small>Collections and deposits, tracked</small>
        </div>
      </li>
    </ul>
  </div>

  <div class="er-foot">OTP-SECURED LOGIN</div>

  </mat-card>

  <mat-card class="login-form">
    <div class="form-card">
      <div class="ym-icon">
        <img [src]="ymLogoPng" alt="EasyRin">
      </div>
      <div class="er-status" *ngIf="!otp"><span class="er-live er-live-g"></span>SECURE LOGIN</div>
      <div class="er-status er-status-wait" *ngIf="otp"><span class="er-live er-live-a"></span>OTP SENT · WAITING</div>
      <mat-card-content>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <h2>Welcome back<span class="er-dot">.</span></h2>
          <p class="er-sub login_text">Login with your personal info to access <span class="er-brandword">Easy<span class="er-rin">Rin</span></span>.</p>

          <mat-form-field class="full-width-input" appearance="outline">
            <mat-label>Mobile number</mat-label>
            <span matPrefix class="er-prefix"><span class="material-icons">smartphone</span>&nbsp;</span>
            <input matInput type="number"  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="10" minlength="10" placeholder="Enter Mobile Number" formControlName="userName" required>
            <mat-hint>10-digit number registered with EasyRin</mat-hint>
            <mat-error *ngIf="isFieldInvalid('userName')">
              Please enter registered Mobile Number
            </mat-error>
          </mat-form-field>
          <!-- <mat-form-field class="full-width-input" appearance="outline">

            <input  matInput type="password" class="form-control" id="exampleInputPassword1" placeholder="Enter your password"
            formControlName="password" [type]="hide1 ? 'text' : 'password'">
            <mat-icon matSuffix (click)="hide1 = !hide1" style=" cursor: pointer;float: right;
              margin: -15px 16px 4px 0px;">
            {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            <mat-error *ngIf="isFieldInvalid('password')">
              Please enter your password
            </mat-error>
          </mat-form-field> -->
          <div>
            <!-- <mat-checkbox><span (click)="focelogout()">Force logout</span></mat-checkbox> -->
            <div  (click)="forgetPass()" (keyup.enter)="forgetPass()" class="linkpass" role="button" tabindex="0">Forgot password?</div>
          </div>

          <p class="er-otp-label" *ngIf="!otp">Get your one-time password via</p>
          <div class="er-otp-choice">
            <button mat-raised-button type="submit" *ngIf="!otp" class="login-btn er-primary" (click)="selectOtpType('MOBILE')"><span class="material-icons er-btn-icon">smartphone</span> Mobile</button>

            <button mat-raised-button type="submit" *ngIf="!otp" class="login-btn er-ghost" (click)="selectOtpType('EMAIL')"><span class="material-icons er-btn-icon">mail_outline</span> Email</button>
          </div>

        </form>
      </mat-card-content>

      <form [formGroup]="otpform" *ngIf="otp" (ngSubmit)="validateOtpsend('otpTrue')">
        <p class="er-otp-msg">{{otpMessage}}</p>
        <mat-form-field class="full-width-input er-otp-field" appearance="outline">
          <input matInput type="text" (keypress)="numberOnly($event)" minlength="6" maxlength="6" placeholder="OTP" formControlName="enterOtp" required>
          <mat-error *ngIf="isOtpInvalid('enterOtp')">
            Please enter valid OTP
          </mat-error>
        </mat-form-field>
        <div class="er-countdown">
          <countdown [config]="{leftTime:180}" *ngIf="!isResendEnable" (event)="handleEvent($event)">$!m!:$!s!</countdown>
        </div>



        <small *ngIf="isResendEnable" class="er-resend">Not received yet!
          <!-- <button (click)="resendOTP()" *ngIf="isResendEnable" class="btn btn-success">Resend</button> -->
          <span (click)="resendOTP()" *ngIf="isResendEnable" class="er-resend-link">Resend</span>
         </small><br>



        <button mat-raised-button class="login-btn er-primary er-submit">Submit</button>

      </form>
    </div>
  </mat-card>



</div>

